import pccm_picture from ".././assets/pccm-picture.png";
import ".././styles/AboutPreview.css";
import { HashLink as Link } from 'react-router-hash-link';

function AboutPreview() {
    return(
       
        
            <div className="about-preview wrapper section">
                <div className="img-container">
                    <img src={pccm_picture} className="pccm-pic"></img>
                </div>
                <div className="text-side">
                    <h2 className="main-text">
                    A Cultural Hub for Filipino-Canadians
                    </h2>
                    <p className="body-text">
                    PCCM is the centre used for workshops, programs & services, arts, music, athletics, cultural activities, classroom for heritage language classes, and banquets.
                    </p>
                    <Link to="/aboutus#aboutus-top" className="button-1 button-shadow">
                        Learn More
                    </Link>
                </div>
            </div>
        
        
        
    );
}

export default AboutPreview;